var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevboxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 316.3 99.5",
    style: {
      enableBackground: "new 0 0 316.3 99.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#020202;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.9,61.9c-3.8,0-5.6,2-5.6,5.9v8.5h14.3V61.9H304.9L304.9,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.3,24c-5,0-9.4,1.6-13.2,4.9V18.3c0-5-2.6-7.5-7.9-7.5h-7.7V54c0.1,7.7,2.4,13.5,7,17.5 c4.3,3.8,10.6,5.7,19.1,5.8c8.4,0.1,14.6-2.3,18.7-7.1c4.1-5.5,6.2-11.9,6.2-19.1C193,33.4,185.7,24.4,171.3,24z M174.5,60.8 c-1.9,2.1-4.2,3.2-7,3.2s-5-1.1-6.8-3.2c-1.8-2.3-2.6-5.6-2.4-10c0.1-4.5,0.9-7.8,2.4-9.8c1.6-2.1,4-3.2,7-3.2s5.3,1.1,6.8,3.2 c1.6,2.3,2.4,5.5,2.4,9.6C177.1,55.4,176.3,58.7,174.5,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241,68.5c3.5-4.8,5.3-10.7,5.3-17.7c0-5.7-1.1-10.6-3.4-14.7c-2.6-4.8-6.5-8.1-11.5-10 c-5.5-1.9-10.8-2.3-15.8-1.1c-9.1,1.9-15,7.1-17.7,15.7c-1,3.4-1.5,6.7-1.5,10c0,9.1,2.7,16.1,8.1,21.1c3,2.6,6.8,4.3,11.4,5.1 c4.6,0.8,8.9,0.6,12.9-0.4C233.9,75.3,238,72.6,241,68.5L241,68.5z M221.2,64.3c-5.8,0-8.7-4.5-8.9-13.4c0.2-7,2.1-11.3,5.7-12.8 c3.5-1.1,6.5-0.6,9,1.7c2,2.6,3.1,6.4,3.2,11.1C230,59.9,226.9,64.3,221.2,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.7,50.2l30.1-46.4h-15.3c-2.9,0-5.2,1.3-6.8,3.8L270,37.8l-7-12.5h-18.5l15.8,24.9l0,0l-30,46.6h15.3 c2.9,0,5.2-1.3,6.8-3.8L270,62.8l7,12.5h18.5L279.7,50.2L279.7,50.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.1,51.9v24.5h16V50.6c0-3.4,0.8-5.8,2.3-7.4c1.5-1.5,3.8-2.3,7-2.3h5.9V24.7C13.5,24,3.1,33,3.1,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.7,24.4c-7.5,0-13.6,2.5-18.3,7.4c-4.3,4.7-6.4,11-6.4,19s2.2,14.4,6.6,19.4c4.3,4.8,10.3,7.2,18.1,7.2 C73.5,77.5,81.6,71.7,85,60H73.7c-2.5,0-4.5,0.7-5.8,2.1c-1.4,1.4-3.6,2.1-6.6,2.1c-2.8,0-5-0.9-6.8-2.8c-1.3-1.3-1.9-3.3-1.9-6.2 h32.8c0.8-9.4-1.3-17.3-6.2-23.6C74.4,26.8,68.2,24.4,60.7,24.4L60.7,24.4z M52.8,44.7c0.4-2.1,1.1-3.8,2.3-4.9 c1.4-1.4,3.3-2.1,5.8-2.1s4.4,0.7,6,2.1c1.1,1.3,1.8,2.9,2.1,4.9H52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.3,31l-7,24.7l-8.7-30.4H84.1L102,76.4h17l17.9-51.1h-12.1C120.8,25.3,118.3,27.2,117.3,31L117.3,31z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevboxLogo);
export default __webpack_public_path__ + "static/media/revbox-logo.0549a5fef21072596c49420b3b29a83b.svg";
export { ForwardRef as ReactComponent };